import $ from 'jquery';

export default class Newsletter {
    constructor(theme) {
        this.theme = theme;

        // Use AJAX for submitting the contact form
        this.$forms = $('.contact-form');
        this.$forms.off('submit').on('submit', this.onSubmit);
        const $success = this.$forms.find('.form-success');
        const $errors = this.$forms.find('.errors');
        if ($errors.length > 0 && $errors.children().length > 0) {
            this.showAlert($errors.eq(0));
        } else if ($success.length > 0) {
            this.showAlert($success.eq(0));
        }
    }

    onSubmit = (event) => {
        event.preventDefault();
        const $form = $(event.target);
        $form.find('.newsletter-spinner').removeClass('hide');
        $form.find('#newsletter-wrapper').addClass('hide');

        $.post('/contact', $form.serialize())
            .done(function () {
                $form.find('.form-success').removeClass('hide');
                $form.find('.newsletter-spinner').addClass('hide');
            })
            .fail(function () {
                $form.off('submit');
                $form.submit();
            })
    }

    showAlert = (content) => {
        $('<div class="page-alert"></div>').append(content.clone()).appendTo('body');
    }
}
